/**
 * @generated SignedSource<<bbe734acc610f5dbed13b1749a362806>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceComplianceRoutinesList_workspace$data = {
  readonly id: string;
  readonly routines: ReadonlyArray<{
    readonly currentSchedule: {
      readonly __typename: "RoutineScheduleDaily";
      readonly weekdays: ReadonlyArray<{
        readonly startTime: {
          readonly hour: number;
          readonly minute: number;
        } | null;
        readonly weekday: number;
      }>;
    } | {
      readonly __typename: "RoutineScheduleMonthly";
      readonly endDay: number | null;
      readonly startDay: number;
    } | {
      readonly __typename: "RoutineScheduleWeekly";
      readonly endWeekday: number | null;
      readonly startWeekday: number | null;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null;
    readonly id: string;
    readonly inProgressOrNextWorkspaceOccasion: {
      readonly issueCount: number;
      readonly storesCompletedCount: number;
      readonly storesCount: number;
    } | null;
    readonly orgTopic: {
      readonly name: string;
    } | null;
    readonly title: string;
    readonly " $fragmentSpreads": FragmentRefs<"WorkspaceRoutinesListItem_Routine">;
  }> | null;
  readonly topics: ReadonlyArray<{
    readonly __typename: "OrgTopic";
  }> | null;
  readonly " $fragmentType": "WorkspaceComplianceRoutinesList_workspace";
};
export type WorkspaceComplianceRoutinesList_workspace$key = {
  readonly " $data"?: WorkspaceComplianceRoutinesList_workspace$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceComplianceRoutinesList_workspace">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "workspaceId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkspaceComplianceRoutinesList_workspace",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "OrgTopic",
      "kind": "LinkedField",
      "name": "topics",
      "plural": true,
      "selections": [
        (v1/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Routine",
      "kind": "LinkedField",
      "name": "routines",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "OrgTopic",
          "kind": "LinkedField",
          "name": "orgTopic",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "workspaceId",
              "variableName": "workspaceId"
            }
          ],
          "concreteType": "RoutineWorkspaceOccasion",
          "kind": "LinkedField",
          "name": "inProgressOrNextWorkspaceOccasion",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "issueCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "storesCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "storesCompletedCount",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "currentSchedule",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endDay",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startDay",
                  "storageKey": null
                }
              ],
              "type": "RoutineScheduleMonthly",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startWeekday",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endWeekday",
                  "storageKey": null
                }
              ],
              "type": "RoutineScheduleWeekly",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RoutineScheduleDailyWeekday",
                  "kind": "LinkedField",
                  "name": "weekdays",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Time",
                      "kind": "LinkedField",
                      "name": "startTime",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "hour",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "minute",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "weekday",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "type": "RoutineScheduleDaily",
              "abstractKey": null
            }
          ],
          "storageKey": null
        },
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WorkspaceRoutinesListItem_Routine"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Workspace",
  "abstractKey": null
};
})();

(node as any).hash = "f87eff5e65d847be43385f3129e63910";

export default node;
